import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useStoreApi } from '../../Hooks/useStoreApi';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  storeType?: string;
  merchantId?: string;
};


export const useAllStores = (queryParams: Params) => {
  const { getAllStores } = useStoreApi();
  // Inject merchantId from localStorage if not present
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const localStorageMerchantId = userData?.userId;
  const mergedParams = {
    ...queryParams,
    merchantId: localStorageMerchantId,
  };
  // Remove empty-string values so we don't send ?storeType= or similar
  const cleanedParams = Object.fromEntries(
    Object.entries(mergedParams).filter(([_, value]) => value !== '')
  );
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getStore', cleanedParams],
    queryFn: () => {
      console.log(cleanedParams, 'cleanedParams in useAllStores');
      return getAllStores(cleanedParams);
    },
    retry: false,
  });

  return {
    data,
    isLoading:isFetching || isRefetching,
    refetch
  };
};

export const UseCreateStores = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createStores } = useStoreApi();
  return useMutation({
    mutationKey: ['CreateStore'],
    mutationFn: (data: any) => createStores(data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Store created successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create Store',
        'error'
      );
    },
  });
};

export const usePatchStore = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useStoreApi();

  return useMutation({
    mutationKey: ['PatchSubAdmin'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`Store ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type || 'Failed to block the Store',
        'error'
      );
    },
  });
};
export const useDeleteStore = () => {
  const queryClient = useQueryClient();
  const { deleteStore } = useStoreApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteSubAdmin'],
    mutationFn: (ids: string[]) => {
      return deleteStore(ids);
    },
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Store deleted successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted Store',
        'error'
      );
    },
  });
};

export const useEditStore = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editStore } = useStoreApi();

  return useMutation({
    mutationKey: ['EditStore'],
    mutationFn: ({ id , data }: { id: string; data: any }) =>
      editStore(id, data),
    onSuccess: (response: any) => {
      
      showMessage(response?.message || 'Store Updated successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          error.response?.data?.message ||
          'Failed to update the Store',
        'error'
      );
    },
  });
};
